import { graphql } from 'react-apollo'
import { DOWNLOAD_FILES } from '../../graphql/mutations'

export default graphql(DOWNLOAD_FILES, { name: 'downloadFiles' })
